export default __webpack_public_path__ + "static/media/downloady.ccb3c95b.svg";